import { ref, watch, type Ref } from 'vue'

import { registerCreditMessages } from '../i18n'

import { useI18n, useLocaleStore } from '@/shared/i18n'

/** Keeps ambient shell surfaces hidden until the lazy credits bundle can resolve their copy. */
export function useCreditMessagesReady(requiredKey: string): Ref<boolean> {
  const localeStore = useLocaleStore()
  const { te } = useI18n()
  const ready = ref(te(requiredKey))

  watch(
    () => localeStore.locale,
    async (locale) => {
      ready.value = te(requiredKey)
      if (ready.value) return
      try {
        await registerCreditMessages(locale)
        ready.value = te(requiredKey)
      } catch {
        ready.value = false
      }
    },
    { immediate: true },
  )

  return ready
}
